import { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";
import {
  ApplyResponseHandlingBodySchema,
  ApplyResponseHandlingResponseSchema,
  ApprovePhoneNumberRequestBodySchema,
  ApprovePhoneNumberRequestResponseSchema,
  BulkImportResultSchema,
  BulkImportTeamsUsersBodySchema,
  BuyPhoneNumberBodySchema,
  BuyPhoneNumberResponseSchema,
  CancelSlackPendingAppPathVarsSchema,
  CancelSlackPendingAppResponseSchema,
  CompleteSlackAppInstallBodySchema,
  CompleteSlackAppInstallResponseSchema,
  ConnectFacebookPageBodySchema,
  ConnectFacebookPageResponseSchema,
  ConnectInstagramBodySchema,
  ConnectInstagramResponseSchema,
  ConnectSlackWorkspaceBodySchema,
  ConnectSlackWorkspaceResponseSchema,
  ConnectWhatsAppCloudBodySchema,
  ConnectWhatsAppCloudResponseSchema,
  CreateAddressBodySchema,
  CreateDeploymentBodySchema,
  CreateKnowledgeFileBodySchema,
  CreateKnowledgeFileResponseSchema,
  CreatePhoneNumberRequestBodySchema,
  CreateSlackAppBodySchema,
  CreateSlackAppResponseSchema,
  CreateSlackBotBodySchema,
  CreateSlackBotPathVarsSchema,
  CreateSlackBotResponseSchema,
  CreateTeamsBotBodySchema,
  CreateTeamsBotResponseSchema,
  CreateTwilioConnectionBodySchema,
  CreateTwilioConnectionResponseSchema,
  CreateWhatsappSenderBodySchema,
  CreateWhatsappSenderResponseSchema,
  CreateWhatsappTemplateBodySchema,
  CreateWhatsappTemplateResponseSchema,
  DeleteAddressBodySchema,
  DeleteDeploymentPathVarsSchema,
  DeleteScriptBodySchema,
  DeleteScriptResponseSchema,
  DeleteSlackAppPathVarsSchema,
  DeleteSlackAppResponseSchema,
  DeleteSlackWorkspacePathVarsSchema,
  DeleteTwilioConnectionPathVarsSchema,
  DeleteTwilioConnectionResponseSchema,
  DeleteWhatsappSenderPathVarsSchema,
  DeleteWhatsappSenderResponseSchema,
  DeleteWhatsappTemplatePathVarsSchema,
  DeleteWhatsappTemplateResponseSchema,
  DeploymentResponseSchema,
  DeploymentRetentionPolicyPathVarsSchema,
  DeploymentRetentionPolicyResponseSchema,
  DeploymentStatisticsResponseSchema,
  EmbedMetadataResponseSchema,
  EmbedPublicStatusResponseSchema,
  EmbedStatisticsResponseSchema,
  ExchangeFacebookTokenBodySchema,
  ExchangeFacebookTokenResponseSchema,
  GenerateApiKeyPathVarsSchema,
  GenerateApiKeyResponseSchema,
  GetAvailablePhoneNumbersQuerySchema,
  GetAvailablePhoneNumbersResponseSchema,
  GetAvailablePhoneNumberTypesQuerySchema,
  GetAvailablePhoneNumberTypesResponseSchema,
  GetAvailableRegulationTypesQuerySchema,
  GetAvailableRegulationTypesResponseSchema,
  GetCallLogsPathVarsSchema,
  GetCallLogsResponseSchema,
  GetCallStatisticsPathVarsSchema,
  GetCallStatisticsResponseSchema,
  GetDeploymentChatroomPathVarsSchema,
  GetDeploymentChatroomQuerySchema,
  GetDeploymentChatroomResponseSchema,
  GetDeploymentPathVarsSchema,
  GetEmbedByIdPathVarsSchema,
  GetEmbedMetadataPathVarsSchema,
  GetEmbedPublicInfoPathVarsSchema,
  GetEmbedPublicStatusPathVarsSchema,
  GetEmbedSessionsPathVarsSchema,
  GetEmbedSessionsQuerySchema,
  GetEmbedSessionsResponseSchema,
  GetEmbedStatisticsPathVarsSchema,
  GetGroupMembersPathVarsSchema,
  GetGroupMembersQuerySchema,
  GetGroupMembersResponseSchema,
  GetKnowledgeFilePathVarsSchema,
  GetKnowledgeFileQuerySchema,
  GetKnowledgeFileResponseSchema,
  GetMyPhoneNumbersResponseSchema,
  GetRegulationRequirementsQuerySchema,
  GetSlackManifestPathVarsSchema,
  GetSlackSetupPathVarsSchema,
  GetStatisticsPathVarsSchema,
  GetTeamsManifestPathVarsSchema,
  GetTeamsManifestPreviewPathVarsSchema,
  GetTelegramBotProfilePathVarsSchema,
  GetTelegramBotProfileResponseSchema,
  GetWhatsappSenderPathVarsSchema,
  GetWhatsappSenderProfilePathVarsSchema,
  GetWhatsappSenderProfileResponseSchema,
  GetWhatsappSenderResponseSchema,
  GetWidgetConfigPathVarsSchema,
  InstallScriptBodySchema,
  InstallScriptResponseSchema,
  ListAddressesQuerySchema,
  ListConnectionPhoneNumbersPathVarsSchema,
  ListConnectionPhoneNumbersResponseSchema,
  ListIncomingSmsParamsSchema,
  ListIncomingSmsResponseSchema,
  ListMessengerPagesQuerySchema,
  ListMessengerPagesResponseSchema,
  ListPhoneNumberRequestsParamsSchema,
  ListPhoneNumberRequestsResponseSchema,
  ListSlackWorkspacesResponseSchema,
  ListTemplateApprovalsQuerySchema,
  ListTemplateApprovalsResponseSchema,
  ListTwilioConnectionsResponseSchema,
  ListWhatsappSendersResponseSchema,
  ListWhatsappTemplatesQuerySchema,
  ListWhatsappTemplatesResponseSchema,
  PhoneNumberIdPathVarsSchema,
  PhoneNumberRequestResponseSchema,
  PhoneNumberUsageResponseSchema,
  PreviewSlackManifestSyncPathVarsSchema,
  PreviewSlackManifestSyncResponseSchema,
  PublishTeamsPackageBodySchema,
  PublishTeamsPackagePathVarsSchema,
  PublishTeamsPackageResponseSchema,
  PurchaseWhatsappPhoneBodySchema,
  PurchaseWhatsappPhoneResponseSchema,
  ReceiveEmbeddedMessageBodySchema,
  ReceiveEmbeddedMessagePathVarsSchema,
  ReceiveEmbeddedMessageResponseSchema,
  RecreateWhatsappSenderPathVarsSchema,
  RecreateWhatsappSenderResponseSchema,
  RefreshSlackBotAppIdPathVarsSchema,
  RefreshSlackBotAppIdResponseSchema,
  RegulationRequirementsResponseSchema,
  RejectPhoneNumberRequestBodySchema,
  RejectPhoneNumberRequestResponseSchema,
  ReleaseMyPhoneNumberResponseSchema,
  SaveComplianceDraftBodySchema,
  SaveComplianceDraftResponseSchema,
  SearchTeamsGroupsQuerySchema,
  SearchTeamsGroupsResponseSchema,
  SearchTeamsUsersQuerySchema,
  SearchTeamsUsersResponseSchema,
  SendMessageBodySchema,
  SendMessagePathVarsSchema,
  SendMessageResponseSchema,
  SlackManifestResponseSchema,
  SlackSetupResponseSchema,
  SubmitA2pRegistrationBodySchema,
  SubmitA2pRegistrationResponseSchema,
  SubmitComplianceBundleBodySchema,
  SubmitComplianceBundleResponseSchema,
  SubmitTemplateApprovalBodySchema,
  SubmitTemplateApprovalResponseSchema,
  SubmitWhatsappSenderVerificationBodySchema,
  SubmitWhatsappSenderVerificationPathVarsSchema,
  SubmitWhatsappSenderVerificationResponseSchema,
  SyncA2pStatusBodySchema,
  SyncA2pStatusResponseSchema,
  SyncComplianceStatusBodySchema,
  SyncComplianceStatusResponseSchema,
  SyncSlackAppScopesBodySchema,
  SyncSlackAppScopesPathVarsSchema,
  SyncSlackAppScopesResponseSchema,
  SyncSlackManifestBodySchema,
  SyncSlackManifestPathVarsSchema,
  SyncSlackManifestResponseSchema,
  TeamsManifestPreviewResponseSchema,
  TeamsManifestResponseSchema,
  TransferPhoneNumberBodySchema,
  TransferPhoneNumberResponseSchema,
  TwilioAddressSchema,
  TwilioConnectionSchema,
  UpdateDeploymentBodySchema,
  UpdateDeploymentPathVarsSchema,
  UpdateSlackBotProfileBodySchema,
  UpdateSlackBotProfilePathVarsSchema,
  UpdateSlackBotProfileResponseSchema,
  UpdateTelegramBotProfileBodySchema,
  UpdateTelegramBotProfilePathVarsSchema,
  UpdateTelegramBotProfileResponseSchema,
  UpdateTwilioConnectionBodySchema,
  UpdateTwilioConnectionPathVarsSchema,
  UpdateWhatsappSenderProfileBodySchema,
  UpdateWhatsappSenderProfilePathVarsSchema,
  UpdateWhatsappSenderProfileResponseSchema,
  UploadBotProfilePicturePathVarsSchema,
  UploadBotProfilePictureResponseSchema,
  UploadChatAttachmentsQuerySchema,
  UploadChatAttachmentsResponseSchema,
  UpsertDeploymentRetentionPolicyBodySchema,
  ValidateSlackTokenBodySchema,
  ValidateSlackTokenResponseSchema,
  VoicePreviewBodySchema,
  WidgetConfigResponseSchema
} from "./schemas";

/**
 * Zod API Validation Schemas for Deployments
 *
 * Uses standard ApiSuccess/ApiError response format.
 * Generator auto-creates both regular (unwrapped) and Raw (full response) hooks.
 *
 * Pattern:
 * - Define UNWRAPPED data schemas (just the data, not ApiSuccessSchema wrapper)
 * - Generator wraps with ApiSuccessSchema automatically
 * - Backend uses createApiSuccess() helper
 * - Frontend gets both useGet() and useGetRaw() hooks
 *
 * See: .readme-claude/api-architecture.md - Standard Response Format
 */
export const ZDeployments = {
  // ============================================================================
  // CORE CRUD OPERATIONS
  // ============================================================================

  /**
   * List deployments
   *
   * Returns: { success: true, data: { deployments }, meta: { total, hasMore } }
   */
  List: {
    method: "GET" as const,
    path: "/api/deployments",
    Response: ApiSuccessSchema(
      z.object({
        deployments: z.array(DeploymentResponseSchema)
      })
    )
  },

  /**
   * Get single deployment
   *
   * Returns: { success: true, data: deployment }
   */
  Get: {
    method: "GET" as const,
    path: "/api/deployments/:id",
    PathVars: GetDeploymentPathVarsSchema,
    Response: ApiSuccessSchema(DeploymentResponseSchema)
  },

  /**
   * Create deployment
   *
   * Returns: { success: true, data: deployment }
   */
  Create: {
    method: "POST" as const,
    path: "/api/deployments",
    Body: CreateDeploymentBodySchema,
    Response: ApiSuccessSchema(DeploymentResponseSchema)
  },

  /**
   * Update deployment
   *
   * Returns: { success: true, data: deployment }
   */
  Update: {
    method: "PUT" as const,
    path: "/api/deployments/:id",
    PathVars: UpdateDeploymentPathVarsSchema,
    Body: UpdateDeploymentBodySchema,
    Response: ApiSuccessSchema(DeploymentResponseSchema)
  },

  /**
   * Delete deployment
   *
   * Returns: { success: true, data: void }
   */
  Delete: {
    method: "DELETE" as const,
    path: "/api/deployments/:id",
    PathVars: DeleteDeploymentPathVarsSchema,
    Response: ApiSuccessSchema(z.void())
  },

  /**
   * Duplicate deployment
   *
   * Creates an inactive, unconnected copy of an existing deployment. The copy
   * carries over the name (suffixed "(copy)"), type, description, agent, and
   * deploymentSettings, but deliberately drops the channel binding
   * (phoneNumberId / oauthConnectionId / apiKeyConnectionId) and starts with
   * isActive=false. Duplicating a deployment implies re-deploying it, which
   * must be validated by the user — so the new deployment is a draft the user
   * reviews and connects (e.g. picks a WhatsApp phone number) before it goes
   * live.
   *
   * Returns: { success: true, data: deployment }
   */
  Duplicate: {
    method: "POST" as const,
    path: "/api/deployments/:id/duplicate",
    // `.uuid()` to match Get/Update/Delete — a bare `z.string()` accepts a
    // malformed id, which Prisma then rejects as a 500 rather than a 400.
    PathVars: z.object({ id: z.string().uuid() }),
    Response: ApiSuccessSchema(DeploymentResponseSchema)
  },

  // ============================================================================
  // NON-CRUD OPERATIONS
  // ============================================================================

  /**
   * Generate API key
   *
   * Generates a JWT-based API key for API-type deployments.
   * The key contains the deploymentId and organizationId for authentication.
   *
   * Returns: { success: true, data: { apiKey } }
   */
  GenerateApiKey: {
    method: "POST" as const,
    path: "/api/deployments/:id/generate-api-key",
    PathVars: GenerateApiKeyPathVarsSchema,
    Response: ApiSuccessSchema(GenerateApiKeyResponseSchema)
  },

  /**
   * Send message to deployment
   *
   * Creates a new chat or sends a message to an existing chat for a deployment.
   * Uses metadata to identify or create the deployment session (e.g., email thread, Slack channel).
   *
   * Returns: { success: true, data: ChatWithMembers }
   */
  SendMessage: {
    method: "POST" as const,
    path: "/api/deployments/:id/message",
    PathVars: SendMessagePathVarsSchema,
    Body: SendMessageBodySchema,
    Response: ApiSuccessSchema(SendMessageResponseSchema)
  },

  /**
   * Get deployment statistics
   *
   * Returns usage statistics for a deployment including:
   * - Session-level message counts
   * - Spending per session
   * - Session metadata (created/updated timestamps)
   *
   * Returns: { success: true, data: DeploymentStatistics[] }
   */
  GetStatistics: {
    method: "GET" as const,
    path: "/api/deployments/:id/statistics",
    PathVars: GetStatisticsPathVarsSchema,
    Response: ApiSuccessSchema(DeploymentStatisticsResponseSchema)
  },

  /**
   * Get or reserve deployment chatroom
   *
   * Gets an existing chatroom for a deployment session, or reserves a new chatroom ID.
   * Used by embedded chat widgets to get or reserve a chatroom ID before the first message is sent.
   *
   * Query params:
   * - sessionId: Session ID (from x-session-id header, also accepted as query param)
   *
   * Returns: { success: true, data: { chatroom: { id, status?, type?, topic? }, isNew: boolean, messages?: [...] } }
   */
  GetDeploymentChatroom: {
    method: "GET" as const,
    path: "/api/deployments/:id/chatroom",
    PathVars: GetDeploymentChatroomPathVarsSchema,
    Query: GetDeploymentChatroomQuerySchema,
    Response: ApiSuccessSchema(GetDeploymentChatroomResponseSchema)
  },

  /**
   * Get Slack manifest
   *
   * Returns the Slack app manifest JSON for creating a Slack app from a deployment.
   * Used to install the deployment as a Slack app in workspaces.
   *
   * Returns: { success: true, data: SlackManifest }
   */
  GetSlackManifest: {
    method: "GET" as const,
    path: "/api/deployments/:id/slack-manifest",
    PathVars: GetSlackManifestPathVarsSchema,
    Response: ApiSuccessSchema(SlackManifestResponseSchema)
  },

  /**
   * Get Slack setup URL
   *
   * Creates a Slack app from the deployment manifest and returns the setup URL.
   * Users can open this URL in a browser to install the integration in their Slack workspace.
   *
   * Returns: { success: true, data: { setupUrl: string } }
   */
  GetSlackSetup: {
    method: "GET" as const,
    path: "/api/deployments/:id/setup-slack",
    PathVars: GetSlackSetupPathVarsSchema,
    Response: ApiSuccessSchema(SlackSetupResponseSchema)
  },

  CreateSlackBot: {
    method: "POST" as const,
    path: "/api/deployments/:id/create-slack-bot",
    PathVars: CreateSlackBotPathVarsSchema,
    Body: CreateSlackBotBodySchema,
    Response: ApiSuccessSchema(CreateSlackBotResponseSchema)
  },

  /**
   * Create Slack App (auto-creation via Manifest API)
   *
   * Creates a Slack app programmatically using config tokens.
   * Returns OAuth URL for user to install the app.
   */
  CreateSlackApp: {
    method: "POST" as const,
    path: "/api/slack/create-app",
    Body: CreateSlackAppBodySchema,
    Response: ApiSuccessSchema(CreateSlackAppResponseSchema)
  },

  /**
   * Complete a Slack app install the SIGNED-IN caller started.
   *
   * Slack redirects the installing browser to `GET /api/slack/app-install/callback`,
   * which forwards `code` and `state` to the frontend and installs nothing; the
   * frontend posts them here. An install another user started — in this
   * organization or any other — is refused exactly as one that does not exist.
   */
  CompleteSlackAppInstall: {
    method: "POST" as const,
    path: "/api/slack/app-install/complete",
    Body: CompleteSlackAppInstallBodySchema,
    Response: ApiSuccessSchema(CompleteSlackAppInstallResponseSchema)
  },

  /**
   * Validate Slack config token
   *
   * Validates a Slack config token and returns workspace info.
   * Used to detect workspace type (standard vs Enterprise Grid).
   */
  ValidateSlackToken: {
    method: "POST" as const,
    path: "/api/slack/validate-token",
    Body: ValidateSlackTokenBodySchema,
    Response: ApiSuccessSchema(ValidateSlackTokenResponseSchema)
  },

  /**
   * Connect Slack workspace
   *
   * Stores workspace config tokens for auto-creating bots.
   * Validates tokens, gets team info, and creates/updates ApiKeyConnection.
   */
  ConnectSlackWorkspace: {
    method: "POST" as const,
    path: "/api/slack/workspace",
    Body: ConnectSlackWorkspaceBodySchema,
    Response: ApiSuccessSchema(ConnectSlackWorkspaceResponseSchema)
  },

  /**
   * List connected Slack workspaces
   *
   * Returns all Slack workspaces connected to the organization.
   * Used by frontend to check if workspace already connected.
   */
  ListSlackWorkspaces: {
    method: "GET" as const,
    path: "/api/slack/workspaces",
    Response: ApiSuccessSchema(ListSlackWorkspacesResponseSchema)
  },

  /**
   * Delete Slack workspace connection
   *
   * Removes a workspace connection. Does not affect bots already created.
   */
  DeleteSlackWorkspace: {
    method: "DELETE" as const,
    path: "/api/slack/workspace/:id",
    PathVars: DeleteSlackWorkspacePathVarsSchema,
    Response: ApiSuccessSchema(z.void())
  },

  /**
   * Delete a Slack bot app from Slack and disconnect from Nexus
   *
   * Calls apps.manifest.delete on Slack (best-effort) then removes the
   * ApiKeyConnection. Falls back to disconnecting only if config token unavailable.
   */
  DeleteSlackApp: {
    method: "DELETE" as const,
    path: "/api/slack/app/:connectionId",
    PathVars: DeleteSlackAppPathVarsSchema,
    Response: ApiSuccessSchema(DeleteSlackAppResponseSchema)
  },

  /**
   * Cancel a pending Slack app (waiting for IT approval).
   *
   * Clears pendingSlackApp from deploymentSettings so the user can start fresh.
   * Idempotent: returns { cancelled: false } if no pending app exists.
   * Returns 400 if the app is mid-creation (status = "claiming").
   */
  CancelSlackPendingApp: {
    method: "DELETE" as const,
    path: "/api/slack/pending-app/:deploymentId",
    PathVars: CancelSlackPendingAppPathVarsSchema,
    Response: ApiSuccessSchema(CancelSlackPendingAppResponseSchema)
  },

  /**
   * Sync Slack app OAuth scopes by patching the app manifest
   *
   * Fetches the current manifest, merges in the requested scopes, and calls
   * apps.manifest.update. Used to automatically add reactions:write when the
   * thinking reaction toggle is enabled.
   */
  SyncSlackAppScopes: {
    method: "POST" as const,
    path: "/api/slack/app/:connectionId/sync-scopes",
    PathVars: SyncSlackAppScopesPathVarsSchema,
    Body: SyncSlackAppScopesBodySchema,
    Response: ApiSuccessSchema(SyncSlackAppScopesResponseSchema)
  },

  /**
   * Sync full Slack app manifest — all default scopes + events + version bump
   *
   * Exports the current manifest, merges in all SLACK_DEFAULT_BOT_SCOPES and
   * SLACK_DEFAULT_BOT_EVENTS, calls apps.manifest.update, and stores the new
   * manifestVersion in ApiKeyConnection.settings. Bots with a stale version
   * should call this to bring their manifest up to date. The workspace admin
   * will still need to reinstall the app for new token scopes to take effect.
   */
  SyncSlackManifest: {
    method: "POST" as const,
    path: "/api/slack/app/:connectionId/sync-manifest",
    PathVars: SyncSlackManifestPathVarsSchema,
    Body: SyncSlackManifestBodySchema,
    Response: ApiSuccessSchema(SyncSlackManifestResponseSchema)
  },

  /**
   * Refresh Slack bot app ID
   *
   * Re-runs auth.test + bots.info to resolve and store the Slack app ID.
   * Useful for debugging manual bots where the appId was not captured on creation.
   */
  RefreshSlackBotAppId: {
    method: "POST" as const,
    path: "/api/slack/app/:connectionId/refresh-app-id",
    PathVars: RefreshSlackBotAppIdPathVarsSchema,
    Response: ApiSuccessSchema(RefreshSlackBotAppIdResponseSchema)
  },

  /**
   * Preview Slack manifest sync (dry-run)
   *
   * Exports the current manifest and computes what scopes/events would be added
   * by a full sync. Used by the confirmation modal to show the user what will change
   * before they trigger the actual sync.
   *
   * Returns: { appName, currentVersion, targetVersion, addedScopes, addedEvents, noConfigToken }
   */
  PreviewSlackManifestSync: {
    method: "GET" as const,
    path: "/api/slack/app/:connectionId/manifest-sync-preview",
    PathVars: PreviewSlackManifestSyncPathVarsSchema,
    Response: ApiSuccessSchema(PreviewSlackManifestSyncResponseSchema)
  },

  /**
   * Get Teams manifest
   *
   * Returns the Microsoft Teams app manifest JSON for creating a Teams app from a deployment.
   * Used to install the deployment as a Teams bot in organizations.
   *
   * Returns: { success: true, data: TeamsManifest }
   */
  GetTeamsManifest: {
    method: "GET" as const,
    path: "/api/deployments/:id/teams-manifest",
    PathVars: GetTeamsManifestPathVarsSchema,
    Response: ApiSuccessSchema(TeamsManifestResponseSchema)
  },

  /**
   * Get Teams manifest preview
   *
   * Returns a preview of the Teams manifest data with editable fields and validation warnings.
   * Used by the pre-publish confirmation modal to show what will be published.
   *
   * Returns: { success: true, data: TeamsManifestPreview }
   */
  GetTeamsManifestPreview: {
    method: "GET" as const,
    path: "/api/deployments/:id/teams-manifest-preview",
    PathVars: GetTeamsManifestPreviewPathVarsSchema,
    Response: ApiSuccessSchema(TeamsManifestPreviewResponseSchema)
  },

  /**
   * Create Teams bot via Azure provisioning
   *
   * Creates Azure AD app + Azure Bot resource + ApiKeyConnection (TEAMS_BOT).
   * Requires an OAuthConnection (TEAMS) with MS Graph admin scopes.
   *
   * Returns: { success: true, data: CreateTeamsBotResponse }
   */
  CreateTeamsBot: {
    method: "POST" as const,
    path: "/api/deployments/teams/create-bot",
    Body: CreateTeamsBotBodySchema,
    Response: ApiSuccessSchema(CreateTeamsBotResponseSchema)
  },

  /**
   * Publish Teams app package to Microsoft App Catalog
   *
   * Uploads the Teams app package to the organization's app catalog.
   * Requires an OAuthConnection (TEAMS) with admin scopes.
   *
   * Returns: { success: true, data: { message } }
   */
  PublishTeamsPackage: {
    method: "POST" as const,
    path: "/api/deployments/:id/publish-teams-package",
    PathVars: PublishTeamsPackagePathVarsSchema,
    Body: PublishTeamsPackageBodySchema,
    Response: ApiSuccessSchema(PublishTeamsPackageResponseSchema)
  },

  /**
   * Search Teams users
   *
   * Search for users in the organization via Microsoft Graph API.
   * Used for access control (selecting who can install the bot).
   *
   * Returns: { success: true, data: TeamsUser[] }
   */
  SearchTeamsUsers: {
    method: "GET" as const,
    path: "/api/deployments/teams/search/users",
    Query: SearchTeamsUsersQuerySchema,
    Response: ApiSuccessSchema(SearchTeamsUsersResponseSchema)
  },

  /**
   * Search Teams groups
   *
   * Search for Azure AD groups via Microsoft Graph API.
   * Used for access control (selecting which groups can install the bot).
   *
   * Returns: { success: true, data: TeamsGroup[] }
   */
  SearchTeamsGroups: {
    method: "GET" as const,
    path: "/api/deployments/teams/search/groups",
    Query: SearchTeamsGroupsQuerySchema,
    Response: ApiSuccessSchema(SearchTeamsGroupsResponseSchema)
  },

  /**
   * Get group members
   *
   * Get members of a specific Azure AD group.
   * Used for previewing who will have access when selecting a group.
   *
   * Returns: { success: true, data: { count, members } }
   */
  GetTeamsGroupMembers: {
    method: "GET" as const,
    path: "/api/deployments/teams/groups/:groupId/members",
    PathVars: GetGroupMembersPathVarsSchema,
    Query: GetGroupMembersQuerySchema,
    Response: ApiSuccessSchema(GetGroupMembersResponseSchema)
  },

  /**
   * Bulk import Teams users
   *
   * Validate multiple user emails and return which are valid.
   * Used for CSV import feature.
   *
   * Returns: { success: true, data: { valid, invalid } }
   */
  BulkImportTeamsUsers: {
    method: "POST" as const,
    path: "/api/deployments/teams/bulk-import-users",
    Body: BulkImportTeamsUsersBodySchema,
    Response: ApiSuccessSchema(BulkImportResultSchema)
  },

  // ============================================================================
  // GOOGLE SHEETS OPERATIONS
  // ============================================================================

  /**
   * Download Google Sheet script as ZIP
   *
   * Returns a ZIP file containing the Google Apps Script for AI integration.
   * Users can upload this to Google Apps Script and use it in their spreadsheets.
   *
   * Returns: Blob (application/zip)
   */
  DownloadGoogleSheetScript: {
    method: "GET" as const,
    path: "/api/deployments/:id/google-sheet-script",
    PathVars: GetDeploymentPathVarsSchema,
    responseType: "blob" as const
  },

  /**
   * Voice Preview
   *
   * Synthesizes a short MP3 sample using the requested OpenAI TTS voice.
   * Returns raw audio/mpeg bytes so operators can audition voices in the UI.
   *
   * Returns: Blob (audio/mpeg)
   */
  VoicePreview: {
    method: "POST" as const,
    path: "/api/deployments/voice-preview",
    Body: VoicePreviewBodySchema,
    responseType: "blob" as const
  },

  /**
   * Install Apps Script to Spreadsheet
   *
   * Auto-installs Nexus Apps Script to a Google Spreadsheet using Apps Script API.
   * Creates container-bound script and stores scriptId for future updates.
   *
   * Returns: { scriptId, scriptUrl, spreadsheetUrl, installedAt }
   */
  InstallScriptToSpreadsheet: {
    method: "POST" as const,
    path: "/api/deployments/:id/install-script",
    PathVars: GetDeploymentPathVarsSchema,
    Body: InstallScriptBodySchema,
    Response: ApiSuccessSchema(InstallScriptResponseSchema)
  },

  /**
   * Uninstall script from a spreadsheet
   *
   * Removes script tracking from Nexus (deploymentSettings + DeploymentSession).
   * Google Apps Script API has no delete endpoint for container-bound scripts,
   * so the user must manually remove the script from Extensions > Apps Script.
   *
   * Returns: { success: true, data: { deleted: true } }
   */
  UninstallScript: {
    method: "POST" as const,
    path: "/api/deployments/:id/uninstall-script",
    PathVars: GetDeploymentPathVarsSchema,
    Body: DeleteScriptBodySchema,
    Response: ApiSuccessSchema(DeleteScriptResponseSchema)
  },

  /**
   * Evaluate Google Sheet with AI
   *
   * Main AI processing endpoint for Google Sheets integration.
   * Reads cell values, processes with AI agent, returns results.
   *
   * Auth: @PublicAPI() - API key in header
   * Returns: Array of arrays in Google Sheets format [["result"]]
   */
  EvaluateSheet: {
    method: "POST" as const,
    path: "/api/deployments/:id/evaluate-sheet",
    PathVars: z.object({ id: z.string().uuid() }),
    Query: z.object({
      header: z.string().min(1),
      data: z.string().min(1),
      skill: z.string().min(1),
      "current-cell": z.string().min(1),
      spreadsheetId: z.string().min(1)
    }),
    Response: ApiSuccessSchema(z.array(z.array(z.string())))
  },

  // ============================================================================
  // EMBED OPERATIONS
  // ============================================================================

  /**
   * Get embed session summaries (PUBLIC - no auth required)
   *
   * Returns conversation summaries for given session IDs.
   * Used by the embed landing screen to show past conversations.
   *
   * Query params:
   * - sessionIds: Comma-separated session UUIDs
   *
   * Returns: { success: true, data: { sessions: EmbedSessionSummary[] } }
   */
  GetEmbedSessions: {
    method: "GET" as const,
    path: "/api/deployments/:id/embed-sessions",
    PathVars: GetEmbedSessionsPathVarsSchema,
    Query: GetEmbedSessionsQuerySchema,
    Response: ApiSuccessSchema(GetEmbedSessionsResponseSchema)
  },

  /**
   * Get embed public info (PUBLIC - no auth required)
   *
   * Returns configuration for embed widgets.
   * Same shape as GetDeployment / GetEmbedById so types flow end-to-end.
   *
   * Returns: { success: true, data: DeploymentResponse }
   */
  GetEmbedPublicInfo: {
    method: "GET" as const,
    path: "/api/deployments/embed/:id/public",
    PathVars: GetEmbedPublicInfoPathVarsSchema,
    Response: ApiSuccessSchema(DeploymentResponseSchema)
  },

  /**
   * Receive embedded message (PUBLIC - no auth required, rate-limited)
   *
   * Receives messages from embed widgets and processes them through the AI agent.
   * Requires x-session-id header for session tracking.
   *
   * Returns: { success: true, data: ChatWithMembers }
   */
  ReceiveEmbeddedMessage: {
    method: "POST" as const,
    path: "/api/deployments/:id/embedded-message",
    PathVars: ReceiveEmbeddedMessagePathVarsSchema,
    Body: ReceiveEmbeddedMessageBodySchema,
    Response: ApiSuccessSchema(ReceiveEmbeddedMessageResponseSchema)
  },

  /**
   * Get embed by ID (AUTHENTICATED)
   *
   * Returns full embed deployment configuration.
   * Used by frontend to display/edit embed settings.
   *
   * Returns: { success: true, data: Deployment }
   */
  GetEmbedById: {
    method: "GET" as const,
    path: "/api/deployments/embed/:id",
    PathVars: GetEmbedByIdPathVarsSchema,
    Response: ApiSuccessSchema(DeploymentResponseSchema)
  },

  /**
   * Get embed widget configuration (AUTHENTICATED)
   *
   * Returns widget-specific configuration for the embed.
   * Used by frontend to preview widget appearance.
   *
   * Returns: { success: true, data: WidgetConfigResponse }
   */
  GetEmbedWidgetConfig: {
    method: "GET" as const,
    path: "/api/deployments/embed/:id/widget-config",
    PathVars: GetWidgetConfigPathVarsSchema,
    Response: ApiSuccessSchema(WidgetConfigResponseSchema)
  },

  /**
   * Get embed metadata (AUTHENTICATED)
   *
   * Returns metadata for an embed deployment.
   * Includes creation date, status, organization info.
   *
   * Returns: { success: true, data: EmbedMetadataResponse }
   */
  GetEmbedMetadata: {
    method: "GET" as const,
    path: "/api/deployments/embed/:id/metadata",
    PathVars: GetEmbedMetadataPathVarsSchema,
    Response: ApiSuccessSchema(EmbedMetadataResponseSchema)
  },

  /**
   * Check embed public status (AUTHENTICATED)
   *
   * Returns whether the embed is publicly accessible.
   *
   * Returns: { success: true, data: { isPublic: boolean } }
   */
  GetEmbedPublicStatus: {
    method: "GET" as const,
    path: "/api/deployments/embed/:id/public-status",
    PathVars: GetEmbedPublicStatusPathVarsSchema,
    Response: ApiSuccessSchema(EmbedPublicStatusResponseSchema)
  },

  /**
   * Get embed statistics (AUTHENTICATED)
   *
   * Returns usage statistics for an embed deployment.
   *
   * Returns: { success: true, data: EmbedStatisticsResponse }
   */
  GetEmbedStatistics: {
    method: "GET" as const,
    path: "/api/deployments/embed/:id/statistics",
    PathVars: GetEmbedStatisticsPathVarsSchema,
    Response: ApiSuccessSchema(EmbedStatisticsResponseSchema)
  },

  /**
   * Create knowledge file (PUBLIC - no auth required)
   *
   * Uploads a knowledge file for an embed chat session.
   * File is uploaded via multipart/form-data.
   *
   * Returns: { success: true, data: CreateKnowledgeFileResponse }
   */
  CreateKnowledgeFile: {
    method: "POST" as const,
    path: "/api/deployments/embed/knowledge/file",
    Body: CreateKnowledgeFileBodySchema,
    Response: ApiSuccessSchema(CreateKnowledgeFileResponseSchema)
  },

  /**
   * Get knowledge file (PUBLIC - no auth required)
   *
   * Retrieves a knowledge file for an embed chat session.
   *
   * Returns: { success: true, data: GetKnowledgeFileResponse }
   */
  GetKnowledgeFile: {
    method: "GET" as const,
    path: "/api/deployments/embed/knowledge/file/:id",
    PathVars: GetKnowledgeFilePathVarsSchema,
    Query: GetKnowledgeFileQuerySchema,
    Response: ApiSuccessSchema(GetKnowledgeFileResponseSchema)
  },

  /**
   * Upload chat attachments (PUBLIC - no auth required)
   *
   * Uploads files as chat attachments for embed sessions.
   * Supports parallel processing and thumbnail generation.
   * Files uploaded via multipart/form-data.
   *
   * Returns: { success: true, data: UploadChatAttachmentsResponse }
   */
  UploadChatAttachments: {
    method: "POST" as const,
    path: "/api/deployments/embed/uploadChatAttachments",
    Query: UploadChatAttachmentsQuerySchema,
    Response: ApiSuccessSchema(UploadChatAttachmentsResponseSchema)
  },

  // ============================================================================
  // PHONE CALL OPERATIONS
  // ============================================================================

  /**
   * Get call logs for phone call deployment
   *
   * Returns the last 100 call log entries for a phone call deployment,
   * including call metadata (from number, duration, price, messages).
   *
   * Returns: { success: true, data: CallLogEntry[] }
   */
  GetCallLogs: {
    method: "GET" as const,
    path: "/api/deployments/:id/call-logs",
    PathVars: GetCallLogsPathVarsSchema,
    Response: ApiSuccessSchema(GetCallLogsResponseSchema)
  },

  /**
   * Get call statistics for phone call deployment
   *
   * Returns aggregated call statistics for the current month, including:
   * - Total spent, total messages, total time
   * - Per-number breakdown (price, duration, messages, last updated)
   *
   * Returns: { success: true, data: { totalSpent, totalNumberOfMessages, totalTimeSpent, data } }
   */
  GetCallStatistics: {
    method: "GET" as const,
    path: "/api/deployments/:id/call-statistics",
    PathVars: GetCallStatisticsPathVarsSchema,
    Response: ApiSuccessSchema(GetCallStatisticsResponseSchema)
  },

  // ============================================================================
  // PHONE NUMBER MANAGEMENT
  // ============================================================================

  /**
   * Get available phone numbers for purchase
   *
   * Returns list of available phone numbers from Twilio based on country and capabilities.
   *
   * Query params:
   * - country: Country code (default: "USA")
   * - sms: Enable SMS capability
   * - mms: Enable MMS capability
   * - voice: Enable voice capability
   * - type: "mobile" | "local" (default: "local")
   *
   * Returns: { success: true, data: PhoneNumberInfo[] }
   */
  GetAvailablePhoneNumberTypes: {
    method: "GET" as const,
    path: "/api/deployments/phone-numbers/available-types",
    Params: GetAvailablePhoneNumberTypesQuerySchema,
    Response: ApiSuccessSchema(GetAvailablePhoneNumberTypesResponseSchema)
  },

  GetAvailableRegulationTypes: {
    method: "GET" as const,
    path: "/api/deployments/phone-numbers/regulation-types",
    Params: GetAvailableRegulationTypesQuerySchema,
    Response: ApiSuccessSchema(GetAvailableRegulationTypesResponseSchema)
  },

  GetRegulationRequirements: {
    method: "GET" as const,
    path: "/api/deployments/phone-numbers/regulation-requirements",
    Params: GetRegulationRequirementsQuerySchema,
    Response: ApiSuccessSchema(RegulationRequirementsResponseSchema)
  },

  SaveComplianceDraft: {
    method: "PUT" as const,
    path: "/api/deployments/phone-numbers/compliance-draft",
    Body: SaveComplianceDraftBodySchema,
    Response: ApiSuccessSchema(SaveComplianceDraftResponseSchema)
  },

  SubmitComplianceBundle: {
    method: "POST" as const,
    path: "/api/deployments/phone-numbers/compliance-submit",
    Body: SubmitComplianceBundleBodySchema,
    Response: ApiSuccessSchema(SubmitComplianceBundleResponseSchema)
  },

  SyncComplianceStatus: {
    method: "POST" as const,
    path: "/api/deployments/phone-numbers/compliance-sync",
    Body: SyncComplianceStatusBodySchema,
    Response: ApiSuccessSchema(SyncComplianceStatusResponseSchema)
  },

  /**
   * Submit A2P 10DLC registration (initial: Customer Profile + Trust Product)
   *
   * Creates Trust Hub resources on the sub-account and submits for Twilio review.
   * Brand registration, campaign, and messaging service happen after async approval.
   */
  SubmitA2pRegistration: {
    method: "POST" as const,
    path: "/api/deployments/phone-numbers/a2p-submit",
    Body: SubmitA2pRegistrationBodySchema,
    Response: ApiSuccessSchema(SubmitA2pRegistrationResponseSchema)
  },

  SyncA2pStatus: {
    method: "POST" as const,
    path: "/api/deployments/phone-numbers/a2p-sync",
    Body: SyncA2pStatusBodySchema,
    Response: ApiSuccessSchema(SyncA2pStatusResponseSchema)
  },

  GetAvailablePhoneNumbers: {
    method: "GET" as const,
    path: "/api/deployments/phone-numbers/available",
    Params: GetAvailablePhoneNumbersQuerySchema,
    Response: ApiSuccessSchema(GetAvailablePhoneNumbersResponseSchema)
  },

  /**
   * Buy a phone number
   *
   * Purchases a phone number from Twilio and associates it with the organization.
   * Deducts the price from the organization's balance.
   *
   * Returns: { success: true, data: PurchasedPhoneNumber }
   */
  BuyPhoneNumber: {
    method: "POST" as const,
    path: "/api/deployments/phone-numbers/buy",
    Body: BuyPhoneNumberBodySchema,
    Response: ApiSuccessSchema(BuyPhoneNumberResponseSchema)
  },

  /**
   * Get my purchased phone numbers
   *
   * Returns all phone numbers owned by the authenticated organization.
   *
   * Returns: { success: true, data: MyPhoneNumber[] }
   */
  GetMyPhoneNumbers: {
    method: "GET" as const,
    path: "/api/deployments/phone-numbers/mine",
    Response: ApiSuccessSchema(GetMyPhoneNumbersResponseSchema)
  },

  /**
   * Get what is currently attached to a phone number (deployments + WhatsApp
   * senders) so the release dialog can show what will be detached.
   */
  GetPhoneNumberUsage: {
    method: "GET" as const,
    path: "/api/deployments/phone-numbers/:phoneNumberId/usage",
    PathVars: PhoneNumberIdPathVarsSchema,
    Response: ApiSuccessSchema(PhoneNumberUsageResponseSchema)
  },

  /**
   * Release a phone number: detaches all deployments + WhatsApp senders, releases
   * it back to Twilio (stops billing), and soft-marks it RELEASED. Irreversible.
   */
  ReleaseMyPhoneNumber: {
    method: "DELETE" as const,
    path: "/api/deployments/phone-numbers/:phoneNumberId",
    PathVars: PhoneNumberIdPathVarsSchema,
    Response: ApiSuccessSchema(ReleaseMyPhoneNumberResponseSchema)
  },

  /**
   * Transfer phone number to subaccount
   *
   * Transfers a phone number from the main Twilio account to a subaccount.
   * Used for organization isolation and billing separation.
   *
   * Returns: { success: true, data: TransferredPhoneNumber }
   */
  TransferPhoneNumber: {
    method: "POST" as const,
    path: "/api/deployments/phone-numbers/transfer",
    Body: TransferPhoneNumberBodySchema,
    Response: ApiSuccessSchema(TransferPhoneNumberResponseSchema)
  },

  /**
   * List Twilio addresses for a sub-account connection
   *
   * Returns all addresses on the sub-account identified by connectionId.
   * Used by the compliance wizard address picker (select existing or create new).
   */
  ListAddresses: {
    method: "GET" as const,
    path: "/api/deployments/phone-numbers/addresses",
    Params: ListAddressesQuerySchema,
    Response: ApiSuccessSchema(z.array(TwilioAddressSchema))
  },

  /**
   * Create a new Twilio address on a sub-account connection
   *
   * Creates an address resource on the Twilio sub-account for regulatory compliance.
   * The address can then be linked to a compliance bundle.
   */
  CreateAddress: {
    method: "POST" as const,
    path: "/api/deployments/phone-numbers/addresses",
    Body: CreateAddressBodySchema,
    Response: ApiSuccessSchema(TwilioAddressSchema)
  },

  DeleteAddress: {
    method: "DELETE" as const,
    path: "/api/deployments/phone-numbers/addresses",
    Body: DeleteAddressBodySchema,
    Response: ApiSuccessSchema(z.object({ deleted: z.literal(true) }))
  },

  // ============================================================================
  // PHONE NUMBER REQUESTS
  // ============================================================================

  /**
   * Create phone number request
   *
   * Users submit a request for a phone number in restricted countries (Belgium, etc.).
   * Replaces "email us" flow with self-service admin approval workflow.
   *
   * Returns: { success: true, data: PhoneNumberRequest }
   */
  CreatePhoneNumberRequest: {
    method: "POST" as const,
    path: "/api/deployments/phone-number-requests",
    Body: CreatePhoneNumberRequestBodySchema,
    Response: ApiSuccessSchema(PhoneNumberRequestResponseSchema)
  },

  /**
   * List phone number requests
   *
   * Returns phone number requests for the authenticated organization.
   * Users see only their org's requests. Admins see all in admin panel.
   *
   * Returns: { success: true, data: { requests, total, hasMore } }
   */
  ListPhoneNumberRequests: {
    method: "GET" as const,
    path: "/api/deployments/phone-number-requests",
    Params: ListPhoneNumberRequestsParamsSchema,
    Response: ApiSuccessSchema(ListPhoneNumberRequestsResponseSchema)
  },

  /**
   * Get phone number request by ID
   *
   * Returns a single phone number request with full details.
   *
   * Returns: { success: true, data: PhoneNumberRequest }
   */
  GetPhoneNumberRequest: {
    method: "GET" as const,
    path: "/api/deployments/phone-number-requests/:id",
    PathVars: z.object({ id: z.string().uuid() }),
    Response: ApiSuccessSchema(PhoneNumberRequestResponseSchema)
  },

  /**
   * Approve phone number request (ADMIN)
   *
   * Admin approves request and assigns a pre-purchased phone number.
   * Creates PhoneNumber record and links to organization.
   *
   * Returns: { success: true, data: { requestId, phoneNumberId, status } }
   */
  ApprovePhoneNumberRequest: {
    method: "POST" as const,
    path: "/api/deployments/phone-number-requests/:id/approve",
    PathVars: z.object({ id: z.string().uuid() }),
    Body: ApprovePhoneNumberRequestBodySchema,
    Response: ApiSuccessSchema(ApprovePhoneNumberRequestResponseSchema)
  },

  /**
   * Reject phone number request (ADMIN)
   *
   * Admin rejects request with reason. User is notified.
   *
   * Returns: { success: true, data: { requestId, status } }
   */
  RejectPhoneNumberRequest: {
    method: "POST" as const,
    path: "/api/deployments/phone-number-requests/:id/reject",
    PathVars: z.object({ id: z.string().uuid() }),
    Body: RejectPhoneNumberRequestBodySchema,
    Response: ApiSuccessSchema(RejectPhoneNumberRequestResponseSchema)
  },

  /**
   * Admin list phone number requests (no org filter)
   *
   * Returns all phone number requests across all organizations.
   * Used by admin panel to review and action requests.
   *
   * Returns: { success: true, data: { requests, total, hasMore } }
   */
  AdminListPhoneNumberRequests: {
    method: "GET" as const,
    path: "/api/admin/phone-number-requests",
    Params: ListPhoneNumberRequestsParamsSchema,
    Response: ApiSuccessSchema(ListPhoneNumberRequestsResponseSchema)
  },

  // ============================================================================
  // INCOMING SMS (SMS Audit Trail)
  // ============================================================================

  /**
   * List incoming SMS messages
   *
   * Admin endpoint for viewing all SMS received via Twilio webhooks.
   * Supports filtering by phone number, organization, date range, etc.
   *
   * Returns: { success: true, data: { total, messages, hasMore } }
   */
  ListIncomingSms: {
    method: "GET" as const,
    path: "/api/admin/incoming-sms",
    Params: ListIncomingSmsParamsSchema,
    Response: ApiSuccessSchema(ListIncomingSmsResponseSchema)
  },

  // ============================================================================
  // TELEGRAM-SPECIFIC OPERATIONS
  // ============================================================================

  /**
   * Get Telegram bot profile
   *
   * Fetches current profile from Telegram API (always fresh, no caching).
   *
   * Returns: { success: true, data: { id, username, displayName, description, shortDescription } }
   */
  GetTelegramBotProfile: {
    method: "GET" as const,
    path: "/api/deployments/:id/telegram/bot-profile",
    PathVars: GetTelegramBotProfilePathVarsSchema,
    Response: ApiSuccessSchema(GetTelegramBotProfileResponseSchema)
  },

  /**
   * Update Telegram bot profile
   *
   * Updates the bot's settings via Telegram Bot API:
   * - name: Display name (1-64 chars)
   * - description: Full profile description (0-512 chars)
   * - shortDescription: Chat list description (0-120 chars)
   * - commands: Bot command menu
   *
   * Returns: { success: true, data: { success, botInfo, updatedFields } }
   */
  UpdateTelegramBotProfile: {
    method: "PUT" as const,
    path: "/api/deployments/:id/telegram/bot-profile",
    PathVars: UpdateTelegramBotProfilePathVarsSchema,
    Body: UpdateTelegramBotProfileBodySchema,
    Response: ApiSuccessSchema(UpdateTelegramBotProfileResponseSchema)
  },

  /**
   * Update Slack bot profile
   *
   * Allows updating Slack bot's profile photo. Display name updates are not
   * supported by Slack API (must be set during app creation).
   *
   * Fields:
   * - photoUrl: URL of image to use as bot profile photo
   *
   * Returns: { success: true, data: { success, botInfo, updatedFields } }
   */
  UpdateSlackBotProfile: {
    method: "PUT" as const,
    path: "/api/deployments/:id/slack/bot-profile",
    PathVars: UpdateSlackBotProfilePathVarsSchema,
    Body: UpdateSlackBotProfileBodySchema,
    Response: ApiSuccessSchema(UpdateSlackBotProfileResponseSchema)
  },

  /**
   * Upload bot profile picture
   *
   * Upload and optimize bot profile picture for deployments (Slack, Telegram, etc.)
   * Creates multiple size variants (@20, @40, @80, @160, @320, @640) and uploads to S3.
   *
   * Note: This is a multipart/form-data endpoint (file upload).
   * Use FormData with 'file' field.
   *
   * Returns: { success: true, data: { success, original, sizes, default } }
   */
  UploadBotProfilePicture: {
    method: "POST" as const,
    path: "/api/deployments/:id/bot-profile-picture",
    PathVars: UploadBotProfilePicturePathVarsSchema,
    Response: ApiSuccessSchema(UploadBotProfilePictureResponseSchema)
  },

  // ============================================================================
  // WHATSAPP-SPECIFIC OPERATIONS
  // ============================================================================

  /**
   * List Twilio connections (subaccounts)
   *
   * Returns all Twilio subaccounts (ApiKeyConnection with service=TWILIO) for the organization.
   * Each connection can manage multiple phone numbers and WhatsApp senders.
   *
   * Returns: { success: true, data: TwilioConnection[] }
   */
  ListTwilioConnections: {
    method: "GET" as const,
    path: "/api/deployments/whatsapp/connections",
    Response: ApiSuccessSchema(ListTwilioConnectionsResponseSchema)
  },

  /**
   * Create Twilio connection
   *
   * Creates a new Twilio subaccount via Twilio API.
   * Returns the created ApiKeyConnection with Twilio credentials.
   *
   * Returns: { success: true, data: TwilioConnection }
   */
  CreateTwilioConnection: {
    method: "POST" as const,
    path: "/api/deployments/whatsapp/connections",
    Body: CreateTwilioConnectionBodySchema,
    Response: ApiSuccessSchema(CreateTwilioConnectionResponseSchema)
  },

  /**
   * Update Twilio connection
   *
   * Updates a Twilio connection (supports updating wabaId and region).
   *
   * Returns: { success: true, data: TwilioConnection }
   */
  UpdateTwilioConnection: {
    method: "PUT" as const,
    path: "/api/deployments/whatsapp/connections/:id",
    PathVars: UpdateTwilioConnectionPathVarsSchema,
    Body: UpdateTwilioConnectionBodySchema,
    Response: ApiSuccessSchema(TwilioConnectionSchema)
  },

  /**
   * Delete Twilio connection
   *
   * Closes a Twilio subaccount and removes the ApiKeyConnection.
   *
   * Returns: { success: true, data: { success: true } }
   */
  DeleteTwilioConnection: {
    method: "DELETE" as const,
    path: "/api/deployments/whatsapp/connections/:id",
    PathVars: DeleteTwilioConnectionPathVarsSchema,
    Response: ApiSuccessSchema(DeleteTwilioConnectionResponseSchema)
  },

  /**
   * List connection phone numbers
   *
   * Returns all phone numbers associated with a Twilio connection.
   * Includes deployment usage info for each number.
   *
   * Returns: { success: true, data: ConnectionPhoneNumber[] }
   */
  ListConnectionPhoneNumbers: {
    method: "GET" as const,
    path: "/api/deployments/whatsapp/connections/:connectionId/phone-numbers",
    PathVars: ListConnectionPhoneNumbersPathVarsSchema,
    Response: ApiSuccessSchema(ListConnectionPhoneNumbersResponseSchema)
  },

  /**
   * Purchase WhatsApp phone number
   *
   * Purchases a phone number via a Twilio subaccount.
   * Number can be used for WhatsApp deployments.
   *
   * Returns: { success: true, data: PurchasedPhoneNumber }
   */
  PurchaseWhatsappPhone: {
    method: "POST" as const,
    path: "/api/deployments/whatsapp/phone-numbers/purchase",
    Body: PurchaseWhatsappPhoneBodySchema,
    Response: ApiSuccessSchema(PurchaseWhatsappPhoneResponseSchema)
  },

  /**
   * List WhatsApp senders
   *
   * Returns all WhatsApp senders (Meta profiles) for the organization.
   * Each sender represents a phone number configured for WhatsApp messaging.
   *
   * Returns: { success: true, data: WhatsappSender[] }
   */
  ListWhatsappSenders: {
    method: "GET" as const,
    path: "/api/deployments/whatsapp/senders",
    Response: ApiSuccessSchema(ListWhatsappSendersResponseSchema)
  },

  /**
   * Get WhatsApp sender
   *
   * Returns details of a specific WhatsApp sender from Twilio API.
   *
   * Returns: { success: true, data: WhatsappSenderDetails }
   */
  GetWhatsappSender: {
    method: "GET" as const,
    path: "/api/deployments/whatsapp/senders/:senderId",
    PathVars: GetWhatsappSenderPathVarsSchema,
    Response: ApiSuccessSchema(GetWhatsappSenderResponseSchema)
  },

  /**
   * Get WhatsApp sender profile
   *
   * Fetch WhatsApp Business Profile from Meta (via Twilio).
   * Returns business name, about text, and profile photo URL.
   *
   * Returns: { success: true, data: WhatsappSenderProfile }
   */
  GetWhatsappSenderProfile: {
    method: "GET" as const,
    path: "/api/deployments/whatsapp/senders/:senderId/profile",
    PathVars: GetWhatsappSenderProfilePathVarsSchema,
    Response: ApiSuccessSchema(GetWhatsappSenderProfileResponseSchema)
  },

  /**
   * Update WhatsApp sender profile
   *
   * Update WhatsApp Business Profile on Meta (via Twilio).
   * Can update display name and about text.
   *
   * Returns: { success: true, data: { updatedFields: string[] } }
   */
  UpdateWhatsappSenderProfile: {
    method: "PATCH" as const,
    path: "/api/deployments/whatsapp/senders/:senderId/profile",
    PathVars: UpdateWhatsappSenderProfilePathVarsSchema,
    Body: UpdateWhatsappSenderProfileBodySchema,
    Response: ApiSuccessSchema(UpdateWhatsappSenderProfileResponseSchema)
  },

  /**
   * Create WhatsApp sender
   *
   * Creates a WhatsApp sender profile (Meta messaging service) via Twilio.
   * Links a phone number to a WhatsApp Business Account.
   *
   * Returns: { success: true, data: WhatsappSender }
   */
  CreateWhatsappSender: {
    method: "POST" as const,
    path: "/api/deployments/whatsapp/senders",
    Body: CreateWhatsappSenderBodySchema,
    Response: ApiSuccessSchema(CreateWhatsappSenderResponseSchema)
  },

  /**
   * Recreate WhatsApp sender (delete + create fresh)
   *
   * Deletes an OFFLINE sender and creates it fresh to retry Meta registration.
   * Used when user has fixed the issue on Meta (e.g., deleted old senders to free WABA slot).
   *
   * Flow: Get existing details → Delete from Twilio → Delete from DB → Create fresh → Return new sender
   *
   * Returns: { success: true, data: WhatsappSender }
   */
  RecreateWhatsappSender: {
    method: "POST" as const,
    path: "/api/deployments/whatsapp/senders/:senderId/recreate",
    PathVars: RecreateWhatsappSenderPathVarsSchema,
    Response: ApiSuccessSchema(RecreateWhatsappSenderResponseSchema)
  },

  /**
   * Delete a single WhatsApp sender (deregister on Twilio/Meta + remove in Nexus).
   * Leaves the phone number intact.
   */
  DeleteWhatsappSender: {
    method: "DELETE" as const,
    path: "/api/deployments/whatsapp/senders/:senderId",
    PathVars: DeleteWhatsappSenderPathVarsSchema,
    Response: ApiSuccessSchema(DeleteWhatsappSenderResponseSchema)
  },

  /**
   * Submit WhatsApp sender verification code
   *
   * Submits the 6-digit OTP from Meta to Twilio to complete phone number verification.
   * Use when the sender is pending (OFFLINE / PENDING_VERIFICATION) and the user has received the code.
   *
   * Returns: { success: true, data: {} }
   */
  SubmitWhatsappSenderVerification: {
    method: "POST" as const,
    path: "/api/deployments/whatsapp/connections/:connectionId/senders/:senderId/verification",
    PathVars: SubmitWhatsappSenderVerificationPathVarsSchema,
    Body: SubmitWhatsappSenderVerificationBodySchema,
    Response: ApiSuccessSchema(SubmitWhatsappSenderVerificationResponseSchema)
  },

  /**
   * List WhatsApp templates
   *
   * Returns WhatsApp message templates for a connection or deployment.
   *
   * Returns: { success: true, data: WhatsappTemplate[] }
   */
  ListWhatsappTemplates: {
    method: "GET" as const,
    path: "/api/deployments/whatsapp/templates",
    Query: ListWhatsappTemplatesQuerySchema,
    Response: ApiSuccessSchema(ListWhatsappTemplatesResponseSchema)
  },

  /**
   * Create WhatsApp template
   *
   * Creates a new WhatsApp message template via Twilio Content API.
   *
   * Returns: { success: true, data: WhatsappTemplate }
   */
  CreateWhatsappTemplate: {
    method: "POST" as const,
    path: "/api/deployments/whatsapp/templates",
    Body: CreateWhatsappTemplateBodySchema,
    Response: ApiSuccessSchema(CreateWhatsappTemplateResponseSchema)
  },

  /**
   * Delete WhatsApp template
   *
   * Deletes a WhatsApp template from Twilio.
   *
   * Returns: { success: true, data: { deleted: true } }
   */
  DeleteWhatsappTemplate: {
    method: "DELETE" as const,
    path: "/api/deployments/whatsapp/templates/:templateId",
    PathVars: DeleteWhatsappTemplatePathVarsSchema,
    Response: ApiSuccessSchema(DeleteWhatsappTemplateResponseSchema)
  },

  /**
   * List template approvals
   *
   * Returns approval status of WhatsApp templates.
   *
   * Returns: { success: true, data: TemplateApproval[] }
   */
  ListTemplateApprovals: {
    method: "GET" as const,
    path: "/api/deployments/whatsapp/templates/approvals",
    Query: ListTemplateApprovalsQuerySchema,
    Response: ApiSuccessSchema(ListTemplateApprovalsResponseSchema)
  },

  /**
   * Submit template for approval
   *
   * Submits a WhatsApp template to Meta for approval.
   *
   * Returns: { success: true, data: TemplateApprovalStatus }
   */
  SubmitTemplateApproval: {
    method: "POST" as const,
    path: "/api/deployments/whatsapp/templates/approvals",
    Body: SubmitTemplateApprovalBodySchema,
    Response: ApiSuccessSchema(SubmitTemplateApprovalResponseSchema)
  },

  // ============================================================================
  // MESSENGER OPERATIONS
  // ============================================================================

  /**
   * List Messenger pages
   *
   * Returns Facebook Messenger page senders from Twilio for a given
   * parent Twilio connection. Each page includes link status (whether
   * a child FB_MESSENGER_PAGE connection and deployment already exist).
   *
   * Returns: { success: true, data: MessengerPage[] }
   */
  ListMessengerPages: {
    method: "GET" as const,
    path: "/api/deployments/messenger/pages",
    Query: ListMessengerPagesQuerySchema,
    Response: ApiSuccessSchema(ListMessengerPagesResponseSchema)
  },

  /**
   * Exchange a Facebook user token for the user's pages (direct Meta, step 1).
   *
   * Frontend sends the short-lived FB.login token; backend caches the page
   * tokens server-side in a handshake and returns pages WITHOUT tokens + flowId.
   * Returns: { success: true, data: { flowId, pages: FacebookPageSafe[] } }
   */
  ExchangeFacebookToken: {
    method: "POST" as const,
    path: "/api/deployments/messenger/facebook/exchange-token",
    Body: ExchangeFacebookTokenBodySchema,
    Response: ApiSuccessSchema(ExchangeFacebookTokenResponseSchema)
  },

  /**
   * Connect a Facebook Page (direct Meta, step 2).
   *
   * Creates the standalone FB_MESSENGER_PAGE connection for the selected page
   * from the cached token (by flowId) and subscribes the webhook.
   * Returns: { success: true, data: { connectionId, pageName } }
   */
  ConnectFacebookPage: {
    method: "POST" as const,
    path: "/api/deployments/messenger/facebook/connect-page",
    Body: ConnectFacebookPageBodySchema,
    Response: ApiSuccessSchema(ConnectFacebookPageResponseSchema)
  },

  /**
   * Connect a WhatsApp number directly via Embedded Signup (one step).
   *
   * Frontend sends the ES authorization code + waba_id + phone_number_id; backend
   * exchanges the code server-side, subscribes the app, registers the number
   * (best-effort), and creates the standalone META_WHATSAPP connection.
   * Returns: { success: true, data: { connectionId, displayPhoneNumber, verifiedName } }
   */
  ConnectWhatsAppCloud: {
    method: "POST" as const,
    path: "/api/deployments/whatsapp/cloud/connect",
    Body: ConnectWhatsAppCloudBodySchema,
    Response: ApiSuccessSchema(ConnectWhatsAppCloudResponseSchema)
  },

  /**
   * Connect an Instagram account directly via Instagram Login (one endpoint).
   *
   * Frontend sends the authorization code + the exact redirectUri it authorized
   * with; backend exchanges the code server-side (short → long token), reads the
   * account, subscribes it to the messages webhook, and creates the standalone
   * META_INSTAGRAM connection. The access token never reaches the browser.
   * Returns: { success: true, data: { connectionId, instagramAccountId, username } }
   */
  ConnectInstagram: {
    method: "POST" as const,
    path: "/api/deployments/instagram/connect",
    Body: ConnectInstagramBodySchema,
    Response: ApiSuccessSchema(ConnectInstagramResponseSchema)
  },

  // ============================================================================
  // RESPONSE HANDLING (NEX-1385)
  // ============================================================================

  /**
   * Apply response handling to all open chats of a deployment
   *
   * When an operator changes defaultResponseHandling on a deployment, existing
   * open chats keep their current value. This endpoint bulk-applies the new
   * value to all currently OPEN chats so the operator does not have to update
   * each conversation individually.
   *
   * Returns: { success: true, data: { updatedCount } }
   */
  ApplyResponseHandling: {
    method: "POST" as const,
    path: "/api/deployments/:deploymentId/apply-response-handling",
    // `Deployment.id` is `@db.Uuid`, and every other deploymentId path var on
    // this manifest is already uuid-checked.
    PathVars: z.object({ deploymentId: z.string().uuid() }),
    Body: ApplyResponseHandlingBodySchema,
    Response: ApiSuccessSchema(ApplyResponseHandlingResponseSchema)
  },

  // ============================================================================
  // CHAT RETENTION POLICY (feature flag `chat_retention`)
  // ============================================================================

  /**
   * Read one deployment's chat-retention policy.
   *
   * A deployment with no stored policy answers the defaults with
   * `configured: false` — never a 404. A deployment outside the caller's
   * organization answers 404.
   *
   * Returns: { success: true, data: policy }
   */
  GetRetentionPolicy: {
    method: "GET" as const,
    path: "/api/deployments/:id/retention-policy",
    PathVars: DeploymentRetentionPolicyPathVarsSchema,
    Response: ApiSuccessSchema(DeploymentRetentionPolicyResponseSchema)
  },

  /**
   * Create or replace one deployment's chat-retention policy.
   *
   * SHRED hard-deletes conversations and cannot be undone; confirming it is the
   * client's job, and every write is audited (`deployment.retention_policy.update`).
   *
   * Returns: { success: true, data: policy }
   */
  UpsertRetentionPolicy: {
    method: "PUT" as const,
    path: "/api/deployments/:id/retention-policy",
    PathVars: DeploymentRetentionPolicyPathVarsSchema,
    Body: UpsertDeploymentRetentionPolicyBodySchema,
    Response: ApiSuccessSchema(DeploymentRetentionPolicyResponseSchema)
  }
} as const;
